module.exports = __webpack_public_path__ + "static/media/home4.9c0ef365.jpg";